import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'launchpad-al-v1',
  templateUrl: './launchpad-al-v1.component.html',
  styleUrls: ['./launchpad-al-v1.component.scss']
})
export class LaunchpadAlV1Component implements OnInit {

  @Input() props: any = [];

  public configObj: any = {
    appName: 'b4u',
    bannerDomain: '',
  };
  public banner = window['AB']['userInfo']['banner'];

  constructor() { }

  ngOnInit(): void {
    if (window.location.href.includes('local')) {
      this.configObj['bannerDomain'] = 'https://www-qa1.safeway.com';
    }
  }

  public analyticsEventsOnClick = (tileName) => {
    tileName = (tileName && tileName.toLowerCase().indexOf('rewards') > -1)  ? 'rewards' : ((tileName && tileName.toLowerCase().indexOf('points') > -1) ? 'points' : tileName);
    if (tileName && tileName.toLowerCase().indexOf('freshpass') > -1) {
      localStorage.setItem('analyticsGetFreshPass', `cta:foru:coupons-deals|button|${tileName}`);
    } else {
      window['eddlLoadComplete'] && tileName && window['AB']?.['DATALAYER']?.analyticsCTATracking(`cta:foru:coupons-deals|button|${tileName}`);
    }
  }

}
